import { render, staticRenderFns } from "./PageLearningFeed.vue?vue&type=template&id=3c1366f0&"
import script from "./PageLearningFeed.vue?vue&type=script&lang=js&"
export * from "./PageLearningFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports